module.exports = __webpack_public_path__ + "img/1572549452.45b56ef2.jpg";